"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var FountainIcon_1 = __importDefault(require("../../../../../../Icons/FountainIcon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SwimPoolFountainAmenity = function (_a) {
    var swim_pool = _a.swim_pool, fountain = _a.fountain;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        swim_pool && (react_1.default.createElement("div", { className: "amenity-item" },
            react_1.default.createElement("div", { className: "push-left" },
                react_1.default.createElement("i", { className: "icon-ic-pool" }),
                react_1.default.createElement("span", { className: "title" }, t('fields.section6.swim_pool'))),
            react_1.default.createElement("div", { className: "amenity-info" }, t('FIELD_OPTIONS.' + swim_pool)))),
        fountain && (react_1.default.createElement("div", { className: "amenity-item" },
            react_1.default.createElement("div", { className: "push-left" },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.fountain_icon },
                    react_1.default.createElement(FountainIcon_1.default, null)),
                react_1.default.createElement("span", { className: "title" }, t('fields.section6.fountain'))),
            react_1.default.createElement("div", { className: "amenity-info" }, t('FIELD_OPTIONS.' + fountain))))));
};
exports.default = react_1.memo(SwimPoolFountainAmenity);
